import { Abbr } from "@site/src/components";

export default function SecondPersonSingular() {
  return (
    <table
      className="table_sticky"
    >
      <colgroup>
        <col />
        <col />
        <col />
        <col />
        <col />
        <col />
        <col />
      </colgroup>
      <tbody>
        <tr>
          <th />
          <th><Abbr>nom.</Abbr></th>
          <th><Abbr>acc.</Abbr></th>
          <th><Abbr>gen.</Abbr></th>
          <th><Abbr>dat.</Abbr></th>
          <th><Abbr>ins.</Abbr></th>
          <th><Abbr>loc.</Abbr></th>
        </tr>
        <tr>
          <th>OCS</th>
          <td>ty</td>
          <td>tebe/tę</td>
          <td>tebe</td>
          <td>tebě/ti</td>
          <td>tobojǫ</td>
          <td>tebě</td>
        </tr>
        <tr>
          <th>Russian</th>
          <td>ty</td>
          <td>tebjá</td>
          <td>tebjá</td>
          <td>tebé</td>
          <td>tobój</td>
          <td>tebé</td>
        </tr>
        <tr>
          <th>Belarussian</th>
          <td>ty</td>
          <td>cjabé</td>
          <td>cjabé</td>
          <td>tabé</td>
          <td>tabój/tabóju</td>
          <td>tabé</td>
        </tr>
        <tr>
          <th>Ukrainian</th>
          <td>ty</td>
          <td>tebé</td>
          <td>tebé</td>
          <td>tobí</td>
          <td>tobóju</td>
          <td>tobí</td>
        </tr>
        <tr>
          <th>Lemko-Rusyn</th>
          <td>ty</td>
          <td>tebe/tja</td>
          <td>tebe/tja</td>
          <td>tobi/ty</td>
          <td>tobom</td>
          <td>tobi</td>
        </tr>
        <tr>
          <th>Polish</th>
          <td>ty</td>
          <td>ciebie/cię</td>
          <td>ciebie</td>
          <td>tobie/ci</td>
          <td>tobą</td>
          <td>tobie</td>
        </tr>
        <tr>
          <th>Cashubian</th>
          <td>të</td>
          <td>cebie/ce/cę</td>
          <td>cebie/ce</td>
          <td>tobie/cë</td>
          <td>tobą</td>
          <td>cebie/tobie</td>
        </tr>
        <tr>
          <th>Lower Sorbian</th>
          <td>ty</td>
          <td>tebje/śi</td>
          <td>tebje/śi</td>
          <td>tebje/śi</td>
          <td>tobu</td>
          <td>tebje</td>
        </tr>
        <tr>
          <th>Upper Sorbian</th>
          <td>ty</td>
          <td>tebje/će</td>
          <td>tebje/će</td>
          <td>tebi/ći</td>
          <td>tobu</td>
          <td>tebi</td>
        </tr>
        <tr>
          <th>Czech</th>
          <td>ty</td>
          <td>tebe/tě</td>
          <td>tebe/tě</td>
          <td>tobě/ti</td>
          <td>tebou</td>
          <td>tobě</td>
        </tr>
        <tr>
          <th>Slovak</th>
          <td>ty</td>
          <td>teba/ťa</td>
          <td>teba/ťa</td>
          <td>tebe/ti</td>
          <td>tebou</td>
          <td>tebe</td>
        </tr>
        <tr>
          <th>Slovene</th>
          <td>ti</td>
          <td>tebe/te</td>
          <td>tebe/te</td>
          <td>tebi/ti</td>
          <td>tebój/tabo</td>
          <td>tebi</td>
        </tr>
        <tr>
          <th>Serbian/Croatian</th>
          <td>tî</td>
          <td>tèbe/te</td>
          <td>tèbe/te</td>
          <td>tèbi/ti</td>
          <td>tòbōm</td>
          <td>tèbi</td>
        </tr>
        <tr>
          <th>Macedonian</th>
          <td>ti</td>
          <td>tebe/te</td>
          <td>—</td>
          <td>tebe/ti</td>
          <td>—</td>
          <td>—</td>
        </tr>
        <tr>
          <th>Bulgarian</th>
          <td>ti</td>
          <td>tébe/te</td>
          <td>—</td>
          <td>ti/tébe</td>
          <td>—</td>
          <td>—</td>
        </tr>
        <tr>
          <th>Interslavic</th>
          <td>
            <b>ty</b>
          </td>
          <td>
            <b>tebe/tę</b>
          </td>
          <td>
            <b>tebe</b>
          </td>
          <td>
            <b>tobě/ti</b>
          </td>
          <td>
            <b>tobojų</b>
          </td>
          <td>
            <b>tobě</b>
          </td>
        </tr>
      </tbody>
    </table>
  )
}
